import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { ContactCIJ } from '@models/event/contact';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CIJWebService {
  constructor(private readonly http: HttpClient) {}

  contact(contactCIJ: ContactCIJ): Observable<unknown> {
    return this.http.post(`${environment.api.event}/v1/cij/contact`, contactCIJ);
  }
}
